import React from "react";

interface Transcription {
  speaker: string;
  startTimeSec: number;
  endTimeSec: number;
}

interface SpeakerStyle {
  color: string;
}

interface SpeakerSegmentsProps {
  transcriptions: Transcription[];
  speakers: string[];
  speakerStyles: SpeakerStyle[];
  duration: number;
}

const SpeakerSegments: React.FC<SpeakerSegmentsProps> = ({ transcriptions, speakers, speakerStyles, duration }) => {
  return (
    <div
      className="speaker_segments"
      style={{ position: "relative", width: "100%", height: "5px" }}>
      {transcriptions.map((transcription, i) => {
        const speakerIndex = speakers.indexOf(transcription.speaker);

        const speakerColor = speakerStyles[speakerIndex]?.color || "gray";
        const startPercentage = (transcription.startTimeSec / duration) * 100;
        const endPercentage = (transcription.endTimeSec / duration) * 100;
        const segmentWidth = endPercentage - startPercentage;

        return (
          <div
            key={i}
            className="speaker_segment"
            style={{
              position: "absolute",
              left: `calc(${startPercentage}% - 2px)`,
              width: `calc(${segmentWidth}% + 4px)`,
              backgroundColor: `${speakerColor}`,
              height: "100%",
              zIndex: 10,
            }}
          />
        );
      })}
    </div>
  );
};

export default SpeakerSegments;
